type PlayTriangleIconProps = {
  color?: string;
  size?: number;
}

export const PlayTriangleIcon = ({ color = '#363BC4', size = 12 }: PlayTriangleIconProps): JSX.Element => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 1.8 C2.5 1.2 3.2 0.9 3.7 1.2L10.3 5.4 C10.8 5.7 10.8 6.3 10.3 6.6L3.7 10.8 C3.2 11.1 2.5 10.8 2.5 10.2V1.8Z"
      fill={color}
    />
  </svg>
);
